var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Tremor Toaster [v0.0.0]
import { Toast, ToastProvider, ToastViewport } from '@web/components/layout/Toast';
import { useToast } from '@web/hocs/useToast';
var Toaster = function () {
    var toasts = useToast().toasts;
    return (_jsxs(ToastProvider, __assign({ swipeDirection: "right" }, { children: [toasts.map(function (_a) {
                var id = _a.id, props = __rest(_a, ["id"]);
                return _jsx(Toast, __assign({}, props), id);
            }), _jsx(ToastViewport, {})] })));
};
export { Toaster };
